import authHeader from "./auth-header";
import axiosInstance from "./instance";

class TicketsService {
  getTickets(data) {
    const close = data.closed;
    if ("closed" in data) delete data.closed;
    return axiosInstance.post("/tickets", data, {
      headers: authHeader(),
      params: {
        closed: close,
      },
    });
  }
  updateTicket(data) {
    return axiosInstance.put("/tickets", data, {
      headers: authHeader(),
    });
  }
  mergeTickets(data) {
    return axiosInstance.post("/tickets_merge", data, {
      headers: authHeader(),
    });
  }
  getUuid() {
    return axiosInstance.get("/get_uuid", {
      headers: authHeader(),
    });
  }
  createTicket(ticket) {
    return axiosInstance.post("/create_ticket", ticket, {
      headers: authHeader(),
    });
  }

  closeTicket(data) {
    return axiosInstance.post("/close_ticket", data, {
      headers: authHeader(),
    });
  }

  reopenTicket(data) {
    return axiosInstance.post("/reopen_ticket", data, {
      headers: authHeader(),
    });
  }

  deleteTicket(data) {
    return axiosInstance.post("/delete_ticket", data, {
      headers: authHeader(),
    });
  }
  getTicketPropositions() {
    return axiosInstance.get("/ticket_propositions", {
      headers: authHeader(),
    });
  }
  createTicketFromProposition(data) {
    return axiosInstance.post("/create_ticket_from_proposition", data, {
      headers: authHeader(),
    });
  }
  createTicketFromPropositions(data) {
    return axiosInstance.post("/create_ticket_from_propositions", data, {
      headers: authHeader(),
    });
  }
  mergePropositionWithTicket(data) {
    return axiosInstance.post("/merge_proposition_with_ticket", data, {
      headers: authHeader(),
    });
  }
  mergePropositionWithTicketBulk(data) {
    return axiosInstance.post("/merge_proposition_with_ticket_bulk", data, {
      headers: authHeader(),
    });
  }
  removeProposition(data) {
    return axiosInstance.post("/remove_proposition", data, {
      headers: authHeader(),
    });
  }
  removePropositionBulk(data) {
    return axiosInstance.post("/remove_proposition_bulk", data, {
      headers: authHeader(),
    });
  }
  getTicketsLastUpdate() {
    return axiosInstance.get("/tickets_check_last_update", {
      headers: authHeader(),
    });
  }
  //currently unused
  getTicketsAttachedToExclusion(params) {
    return axiosInstance.get("/tickets_attached_to_exclusion", {
      params,
      headers: authHeader(),
    });
  }
}

export default new TicketsService();
